import React from 'react';
import Images from '@dashboard/components/Formik/components/Images';
import useProduct from '../useProduct';

// `productId` targets a product outside the page (an order bump); omitted, it
// edits the page's own product.
export default function ProductMediaForm({ productId, maxItems }) {
  const { product, attachMedia, detachMedia, updateProduct } = useProduct(productId);

  if (!product) return null;

  return (
    <Images
      media={product.media}
      maxItems={maxItems}
      onAttach={fileId => attachMedia.mutateAsync(fileId)}
      onDetach={fileId => detachMedia.mutateAsync(fileId)}
      onReorder={media => updateProduct.mutateAsync({ media })}
    />
  );
}
